import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import BaseTableCell from 'components/molecules/TableCells/BaseTableCell/BaseTableCell';

const StyledBadgeTableCell = styled(BaseTableCell)`
  ${ComponentStyles}
`;

StyledBadgeTableCell.propTypes = {
  theme: PropTypes.object
};

export default StyledBadgeTableCell;
